import controller from './slide.controller';
import template from './slide.tmpl.html';

const wsCarouselSlideComponent = {
  template,
  controller,
  transclude: true,
  require: {
    carouselCtrl: '^wsCarousel',
  },
};

export default wsCarouselSlideComponent;



// WEBPACK FOOTER //
// ./src/carousel/slide/slide.component.js